import { t } from 'services/i18n'
import { ButtonType } from '@junglescout/edna'

// TODO(EXP-437): confirm final Cobalt demo-booking URL with marketing.
export const COBALT_DEMO_URL =
  'https://www.junglescout.com/enterprise/demo/?utm_source=catalyst&utm_medium=plg&utm_campaign=csv_export_limit'

export const COBALT_UPGRADE_LINKS = [
  {
    label: t('dashboard:WidgetCard.upSellWidget.tourButton', 'Take a Tour'),
    type: ButtonType.SECONDARY_BLUE,
    url:
      'https://www.junglescout.com/enterprise/product-tour/?utm_source=catalyst&utm_medium=plg&utm_campaign=tour',
    tracking: {
      text: 'Take a Tour',
      product: 'Jungle Scout',
      type: 'link'
    }
  },
  {
    label: t('dashboard:WidgetCard.upSellWidget.demoButton', 'Get a Demo'),
    type: ButtonType.PRIMARY_BLUE,
    url:
      'https://www.junglescout.com/enterprise/demo/?utm_source=catalyst&utm_medium=plg&utm_campaign=demo',
    tracking: {
      text: 'Get a Demo',
      product: 'Jungle Scout',
      type: 'link'
    }
  }
]
